<template>
  <j-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-divider orientation="left">{{ $t('留言信息') }}</a-divider>
            <a-col :span="8">
              <a-form-model-item :label="$t('留言类型')" prop="complaintsType">
                <a-radio-group v-model="model.complaintsType">
                  <a-radio value="0">{{ $t('咨询') }}</a-radio>
                  <a-radio value="1">{{ $t('建议') }}</a-radio>
                  <a-radio value="2">{{ $t('投诉') }}</a-radio>
                  <a-radio value="3">{{ $t('其他') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('用户名称')" prop="userName">
                <a-input v-model="model.userName"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('用户联系电话')" prop="userPhone">
                <a-input v-model="model.userPhone"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('用户地址')" prop="userAddress">
                <a-input v-model="model.userAddress"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('创建时间')" prop="createTime">
                <a-input v-model="model.createTime"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('留言描述')" prop="complaintsDetail">
                <a-textarea v-model="model.complaintsDetail" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('图片')" prop="complaintsPicture">
                <!-- <JUpload v-model="fileList" @change="uploadChange"/> -->
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="complaintsPicture" :disabled="true"></j-image-upload>
              </a-form-model-item>
            </a-col>
            <template v-if="model.complaintsResponse">
              <a-divider orientation="left">{{ $t('处理信息') }}</a-divider>
              <a-col :span="12">
                <a-form-model-item :label="$t('处理人姓名')" prop="complaintsProcessors">
                  <a-input v-model="model.complaintsProcessors"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('处理人联系方式')" prop="complaintsProcessorsPhone">
                  <a-input v-model="model.complaintsProcessorsPhone"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('是否已解决')" prop="isResolved">
                  <a-radio-group v-model="model.isResolved">
                    <a-radio :value="0">{{ $t('已解决') }}</a-radio>
                    <a-radio :value="1">{{ $t('未解决') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('处理描述')" prop="complaintsResponse">
                  <a-textarea v-model="model.complaintsResponse" :placeholder="$t('请输入处理描述')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      JUpload,
      JImageUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        validatorRules: {},
        url: {
          queryById: "/jeecg-charge/oa/userComplaints/queryById",
        },
        fileList: [],
        complaintsPicture:''
      }
    },
    methods: {
      init(row){
        this.visible = true;
        this.title = this.$t('详情');
        this.disableSubmit = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.fileList = JSON.parse(this.model.complaintsPicture);
        let arr = JSON.parse(this.model.complaintsPicture);
        if(arr.length>0){
          this.$nextTick(()=>{
            this.$set(this,'complaintsPicture',arr.join(','));
          })
        }else{
          this.$nextTick(()=>{
            this.$set(this,'complaintsPicture','');
          })
        }
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>